export default __webpack_public_path__ + "resources/icons/n141-44b9.png";